import {ModalController} from "ionic-angular";
import 'rxjs/add/operator/map';
import * as MarkerClusterer from 'node-js-marker-clusterer';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';

declare var google;

/*
  Generated class for the GoogleMapsClusterProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class GoogleMapsClusterProvider {

  markerCluster: any;
  locations: any = [];
  markers: any = [];

  constructor(
    public http: Http,
    private modalCtrl: ModalController,
  ) {
    console.log('Hello GoogleMapsClusterProvider Provider');
  }

  addCluster(map, locations) {

    this.locations = [];
    for (const loc of locations) {
      const obj = {
        lat: parseFloat(loc.lat),
        lng: parseFloat(loc.lng),
        icon: 'assets/images/attendance/' + (loc.flag === 'start' ? 'sficon-placeholder2-blue.png' : 'sficon-placeholder2-orange.png')
      };
      this.locations.push(obj);
    }
    console.log(this.locations, 'FROM GOOGLE CLUSTER');

    if (google.maps) {

      // Convert locations into array of markers
      this.markers = [];
      this.markers = this.locations.map((obj) => {

        const location = {
          lat: obj.lat,
          lng: obj.lng
        };
        const icon = obj.icon;
        console.log('obj', obj);
        return new google.maps.Marker({
          position: location,
          icon: icon
        });
      });
      console.log(this.markers);
      this.markerCluster = new MarkerClusterer(map, this.markers, {imagePath: 'assets/images/attendance/m'});
    } else {
      console.warn('Google maps needs to be loaded before adding a cluster');
    }
  }

  addClusterWithEvent(map, locations) {
    this.locations = [];
    for (const loc of locations) {
      const obj = {
        lat: parseFloat(loc.lat),
        lng: parseFloat(loc.lng),
        icon: 'assets/images/attendance/' + (loc.flag === 'start' ? 'sficon-placeholder2-blue.png' : 'sficon-placeholder2-orange.png'),
        person: loc.person,
        flag: loc.flag,
      };
      this.locations.push(obj);
    }

    if (google.maps) {
      // Convert locations into array of markers
      const that = this;
      this.markers = [];
      this.markers = this.locations.map((obj) => {

        const location = {
          lat: obj.lat,
          lng: obj.lng
        };
        const icon = obj.icon;
        const marker = new google.maps.Marker({
          position: location,
          icon: icon,
          person: obj.person,
          flag: obj.flag,
        });
        marker.addListener('click', function () {
          that.clickEvent(this);
        });
        return marker;
      });
      this.markerCluster = new MarkerClusterer(map, this.markers, {imagePath: 'assets/images/attendance/m'});
    } else {
      console.warn('Google maps needs to be loaded before adding a cluster');
    }
  }

  async clickEvent(e) {
    const {person, flag} = e;
    const modal = this.modalCtrl.create('MapsMarkerModalPage', {person, flag}, {
      cssClass: "grd-modal-rating",
      showBackdrop: true,
      enableBackdropDismiss: true
    });
    await modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/google-maps-cluster/google-maps-cluster.ts